/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Map_Path_OnlyInputs */

const en_automation_map_path_only = /** @type {(inputs: Automation_Map_Path_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Path taken only`)
};

const pt_br2_automation_map_path_only = /** @type {(inputs: Automation_Map_Path_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somente o caminho percorrido`)
};

/**
* | output |
* | --- |
* | "Path taken only" |
*
* @param {Automation_Map_Path_OnlyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_map_path_only = /** @type {((inputs?: Automation_Map_Path_OnlyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Map_Path_OnlyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_map_path_only(inputs)
	return pt_br2_automation_map_path_only(inputs)
});